(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2846],{

/***/ 99994:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/movies/[slug]",
      function () {
        return __webpack_require__(65242);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ days_filter; }
});

// UNUSED EXPORTS: DaysFilter

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(16216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utility/luxon/index.ts
var luxon = __webpack_require__(90255);
// EXTERNAL MODULE: ./src/components/shared/muvi-tabs.tsx
var muvi_tabs = __webpack_require__(77044);
;// CONCATENATED MODULE: ./src/logic/helpers/check-is-prev-day.ts
function checkIsPrevDay(currentDate, prevDate) {
    return currentDate.getFullYear() === prevDate.getFullYear() && currentDate.getMonth() === prevDate.getMonth() && currentDate.getDate() > prevDate.getDate();
}

;// CONCATENATED MODULE: ./src/logic/helpers/check-is-same-days.ts
/**
 * Check if two dates are the same day.
 * @param {Date} d1 - Date - The first date to compare
 * @param {Date} d2 - Date - The date to compare to.
 * @returns the value of the variable x.
 */ function checkIsSameDays(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/movie-details/showtimes/days-filter.tsx



/* eslint-disable react-hooks/exhaustive-deps */ 







var DaysFilter = function(param) {
    var sessionsDate = param.sessionsDate, showTimeDate = param.showTimeDate, selectDate = param.selectDate, returnFirstEnabledDate = param.returnFirstEnabledDate;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)(false), activeTab = ref[0], setActiveTab = ref[1];
    (0,react.useEffect)(function() {
        if ((sessionsDate === null || sessionsDate === void 0 ? void 0 : sessionsDate.length) !== 0 && !showTimeDate) {
            var firstEnabledDate = sessionsDate[0];
            setActiveTab(0);
            returnFirstEnabledDate(firstEnabledDate);
        }
    }, [
        sessionsDate
    ]);
    (0,react.useEffect)(function() {
        if (showTimeDate) {
            var index = sessionsDate.findIndex(function(_session) {
                return _session.date === showTimeDate;
            });
            setActiveTab(index);
        }
    }, [
        showTimeDate,
        sessionsDate
    ]);
    var handleSessionFilterLabel = function(_session, index) {
        var todayShort;
        var userDate = new Date();
        if (checkIsPrevDay(userDate, new Date(_session === null || _session === void 0 ? void 0 : _session.date))) {
            todayShort = intl.formatMessage({
                id: "global.now"
            });
        } else if (checkIsSameDays(userDate, new Date(_session === null || _session === void 0 ? void 0 : _session.date)) && index === 0) {
            todayShort = intl.formatMessage({
                id: "today"
            });
        } else {
            todayShort = luxon/* DateTime.fromISO */.o.fromISO(_session === null || _session === void 0 ? void 0 : _session.date, {
                locale: locale
            }).weekdayShort;
        }
        var todayNumber = luxon/* DateTime.fromISO */.o.fromISO(_session.date, {
            locale: locale
        }).day;
        var monthShort = luxon/* DateTime.fromISO */.o.fromISO(_session.date, {
            locale: locale
        }).monthShort;
        var fontColor = index === activeTab ? theme.palette.common.white : theme.palette.grey[80];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    sx: {
                        fontWeight: 400,
                        fontSize: (0,typography/* pxToRem */.Q)(12),
                        LineHeight: (0,typography/* pxToRem */.Q)(24),
                        color: fontColor,
                        textTransform: "none"
                    },
                    children: todayShort
                }),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    sx: {
                        fontWeight: 900,
                        fontSize: (0,typography/* pxToRem */.Q)(16),
                        LineHeight: (0,typography/* pxToRem */.Q)(24),
                        color: fontColor
                    },
                    children: todayNumber
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    sx: {
                        fontWeight: 400,
                        fontSize: (0,typography/* pxToRem */.Q)(16),
                        LineHeight: (0,typography/* pxToRem */.Q)(24),
                        color: fontColor
                    },
                    children: monthShort
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(muvi_tabs/* default */.Z, {
        slideSx: {
            width: {
                mobile: "54px",
                tablet: (0,typography/* pxToRem */.Q)(69)
            }
        },
        swiperSx: {
            paddingX: (0,typography/* pxToRem */.Q)(30)
        },
        slideToClickedSlide: true,
        slidesPerGroupAuto: true,
        children: sessionsDate === null || sessionsDate === void 0 ? void 0 : sessionsDate.map(function(session, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                id: "movie-day-".concat(index),
                component: "button",
                sx: (0,_object_spread/* default */.Z)({
                    width: "100%",
                    minWidth: "unset",
                    height: "".concat((0,typography/* pxToRem */.Q)(92), " !important"),
                    background: theme.palette.lightGrey.main,
                    borderRadius: "10px",
                    border: "none",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    transition: "background-color 0.2s ease-in-out"
                }, activeTab === index && {
                    color: "".concat(theme.palette.common.white, " !important"),
                    backgroundColor: theme.palette.primary.main
                }),
                onClick: function() {
                    return selectDate(session.date);
                },
                children: handleSessionFilterLabel(session, index)
            }, session.date);
        })
    });
};
/* harmony default export */ var days_filter = (DaysFilter);


/***/ }),

/***/ 89183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34841);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_3__);




/**
 * It's a function that takes in a bunch of props and returns a bunch of meta tags.
 * @param  - FC<SeoProps> = ({
 * @returns A React component.
 */ var Seo = function(param) {
    var description = param.description, title = param.title, image = param.image, pagePath = param.pagePath, canonical = param.canonical, noIndex = param.noIndex, noFollow = param.noFollow, components = param.components;
    var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_3___default()().publicRuntimeConfig;
    var nextPublicBaseUrl = publicRuntimeConfig.nextPublicBaseUrl;
    var handleCanonicalUrl = function(url) {
        return url.split(/[?#]/)[0];
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: handleCanonicalUrl(canonical || pagePath === "/" ? "" : "".concat(nextPublicBaseUrl).concat(pagePath))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: handleCanonicalUrl("".concat(nextPublicBaseUrl, "en").concat(pagePath === null || pagePath === void 0 ? void 0 : pagePath.slice(2))),
                hrefLang: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: handleCanonicalUrl("".concat(nextPublicBaseUrl, "en").concat(pagePath === null || pagePath === void 0 ? void 0 : pagePath.slice(2))),
                hrefLang: "x-default"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                href: handleCanonicalUrl("".concat(nextPublicBaseUrl, "ar").concat(pagePath === null || pagePath === void 0 ? void 0 : pagePath.slice(2))),
                hrefLang: "ar"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image ? image : "".concat(nextPublicBaseUrl).concat(_public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src.slice */ .Z.src.slice(1))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "image:height",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image ? image : "".concat(nextPublicBaseUrl).concat(_public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src.slice */ .Z.src.slice(1))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: "".concat(nextPublicBaseUrl).concat(pagePath === "/" ? "" : pagePath)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "article"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "muvi Cinemas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:site",
                content: "@muvicinemas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:creator",
                content: "@muvicinemas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image ? image : "".concat(nextPublicBaseUrl).concat(_public_icons_shared_logo_share_og_png__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src.slice */ .Z.src.slice(1))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image:width",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:image:height",
                content: "250"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:url",
                content: "".concat(nextPublicBaseUrl).concat(pagePath === "/" ? "" : pagePath)
            }),
            (noIndex || noFollow) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: noIndex && noFollow ? "noindex,nofollow" : noIndex ? "noindex" : "nofollow"
            }),
            !!components && components()
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Seo);


/***/ }),

/***/ 4997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ CloseButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54799);
/* harmony import */ var _icon_24__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97946);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);





var DialogCloseIcon = "/icons/dialog/close.svg";
var CloseButton = function(param) {
    var _icon = param.icon, icon = _icon === void 0 ? DialogCloseIcon : _icon, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, sx = param.sx, handleClick = param.handleClick;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        id: "close-icon",
        "aria-label": intl.formatMessage({
            id: "images.title.close"
        }),
        disabled: disabled,
        onClick: handleClick,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            position: "absolute",
            top: 12,
            left: 12,
            opacity: disabled ? 0.4 : 1
        }, sx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_24__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            icon: icon,
            title: "alt.close"
        })
    });
};


/***/ }),

/***/ 2155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ movie_details_info; }
});

// UNUSED EXPORTS: MovieInfo

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
// EXTERNAL MODULE: ./src/components/shared/image-box-future.tsx
var image_box_future = __webpack_require__(58718);
;// CONCATENATED MODULE: ./src/components/movie-details/casting-name-with-img.tsx




var CastNameWithImg = function(castNameWithImgProps) {
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        component: "div",
        sx: {
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "column",
            mr: (0,typography/* pxToRem */.Q)(16),
            width: "104px",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                img: castNameWithImgProps === null || castNameWithImgProps === void 0 ? void 0 : castNameWithImgProps.img,
                title: castNameWithImgProps === null || castNameWithImgProps === void 0 ? void 0 : castNameWithImgProps.name,
                objectFit: "cover",
                sx: {
                    borderRadius: "15px",
                    width: "90px",
                    height: "92px",
                    overflow: "hidden",
                    pt: castNameWithImgProps.img ? "0" : "10px",
                    background: "#eaecef"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "p",
                sx: {
                    fontSize: (0,typography/* pxToRem */.Q)(18),
                    color: theme.palette.grey[50],
                    textAlign: "center",
                    my: (0,typography/* pxToRem */.Q)(8),
                    overflowWrap: "anywhere"
                },
                children: castNameWithImgProps.name
            })
        ]
    });
};
/* harmony default export */ var casting_name_with_img = (CastNameWithImg);

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
;// CONCATENATED MODULE: ./src/components/movie-details/casting-title-component.tsx




var CastTitle = function(castTitleProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "h3",
        sx: {
            fontSize: (0,typography/* pxToRem */.Q)(22),
            fontWeight: "700",
            mb: (0,typography/* pxToRem */.Q)(16),
            mt: (0,typography/* pxToRem */.Q)(32)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
            id: castTitleProps.title
        })
    });
};
/* harmony default export */ var casting_title_component = (CastTitle);

;// CONCATENATED MODULE: ./src/components/movie-details/casting-title-with-text.tsx




var CastTitleWithText = function(castTitleWithTextProps) {
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(casting_title_component, {
                title: castTitleWithTextProps.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "p",
                sx: {
                    fontSize: (0,typography/* pxToRem */.Q)(20),
                    color: theme.palette.grey[50]
                },
                children: castTitleWithTextProps.text || "-"
            })
        ]
    });
};
/* harmony default export */ var casting_title_with_text = (CastTitleWithText);

// EXTERNAL MODULE: ./src/utility/luxon/index.ts
var luxon = __webpack_require__(90255);
;// CONCATENATED MODULE: ./src/components/movie-details/genre-title.tsx



var GenreTitle = function(genreTitleProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        component: "span",
        sx: {
            fontSize: (0,typography/* pxToRem */.Q)(18),
            color: genreTitleProps.color,
            backgroundColor: genreTitleProps.bgColor,
            borderRadius: "37px",
            px: (0,typography/* pxToRem */.Q)(12),
            py: (0,typography/* pxToRem */.Q)(6),
            mr: (0,typography/* pxToRem */.Q)(8),
            textAlign: "center"
        },
        children: genreTitleProps.title
    });
};
/* harmony default export */ var genre_title = (GenreTitle);

// EXTERNAL MODULE: ./src/components/shared/icon-24.tsx
var icon_24 = __webpack_require__(97946);
// EXTERNAL MODULE: ./src/logic/hooks/use-film-formatter.tsx
var use_film_formatter = __webpack_require__(95102);
;// CONCATENATED MODULE: ./src/components/shared/movie-details-info.tsx











var timeIcon = "/icons/movie-details/time.svg";
var AvatarImg = "/icons/side-menu/avatar.svg";
var MovieInfo = function(movieInfoProps) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var theme = (0,useTheme/* default */.Z)();
    var ref20 = (0,use_film_formatter/* default */.Z)((ref = movieInfoProps.data) === null || ref === void 0 ? void 0 : ref.film), formattedDuration = ref20.formattedDuration, durationWithRateWithRtl = ref20.durationWithRateWithRtl;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        component: "section",
        sx: (0,_define_property/* default */.Z)({
            width: "100%",
            background: theme.palette.layout.bgSecondary,
            borderRadius: "12px",
            px: (0,typography/* pxToRem */.Q)(40),
            py: (0,typography/* pxToRem */.Q)(53)
        }, theme.breakpoints.down("laptop"), {
            pt: 0,
            mb: (0,typography/* pxToRem */.Q)(16)
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: "h2",
                sx: {
                    fontSize: (0,typography/* pxToRem */.Q)(28),
                    fontWeight: "700",
                    mb: (0,typography/* pxToRem */.Q)(32)
                },
                children: movieInfoProps === null || movieInfoProps === void 0 ? void 0 : (ref1 = movieInfoProps.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.film) === null || ref2 === void 0 ? void 0 : ref2.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "div",
                sx: {
                    display: "flex",
                    mb: (0,typography/* pxToRem */.Q)(21),
                    alignItems: "center"
                },
                children: [
                    formattedDuration && /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                        icon: timeIcon,
                        title: "images.title.show_time"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "p",
                        sx: {
                            fontSize: (0,typography/* pxToRem */.Q)(22),
                            color: theme.palette.grey[50],
                            ml: (0,typography/* pxToRem */.Q)(5)
                        },
                        children: durationWithRateWithRtl
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "div",
                sx: {
                    display: "flex",
                    flexWrap: "wrap",
                    mb: (0,typography/* pxToRem */.Q)(29)
                },
                children: movieInfoProps === null || movieInfoProps === void 0 ? void 0 : (ref3 = movieInfoProps.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.film) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.genres) === null || ref5 === void 0 ? void 0 : ref5.slice(0, 2).map(function(genre) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(genre_title, {
                        title: genre.name,
                        color: genre.fontColor,
                        bgColor: genre.backgroundColor
                    }, genre.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(casting_title_with_text, {
                text: movieInfoProps === null || movieInfoProps === void 0 ? void 0 : (ref6 = movieInfoProps.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.film) === null || ref7 === void 0 ? void 0 : ref7.synopsis,
                title: "movie_details.synopsis"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(casting_title_with_text, {
                text: luxon/* DateTime.fromISO */.o.fromISO(movieInfoProps === null || movieInfoProps === void 0 ? void 0 : (ref8 = movieInfoProps.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.film) === null || ref9 === void 0 ? void 0 : ref9.releaseDate).toFormat("dd/MM/yyyy"),
                title: "movie_details.release_date"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: "div",
                sx: {
                    display: "flex",
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "div",
                        sx: {
                            mr: (0,typography/* pxToRem */.Q)(30)
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(casting_title_with_text, {
                            text: movieInfoProps === null || movieInfoProps === void 0 ? void 0 : (ref10 = movieInfoProps.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.film) === null || ref11 === void 0 ? void 0 : ref11.movieLang,
                            title: "movie_details.movie_language"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(casting_title_with_text, {
                        text: movieInfoProps === null || movieInfoProps === void 0 ? void 0 : (ref12 = movieInfoProps.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.film) === null || ref13 === void 0 ? void 0 : ref13.subtitle,
                        title: "movie_details.subtitle"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(casting_title_component, {
                title: "movie_details.director"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "div",
                sx: {
                    display: "flex",
                    flexWrap: "wrap"
                },
                children: movieInfoProps === null || movieInfoProps === void 0 ? void 0 : (ref14 = movieInfoProps.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.film) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.directors) === null || ref16 === void 0 ? void 0 : ref16.map(function(director) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(casting_name_with_img, {
                        img: director.imageUrl || AvatarImg,
                        name: director.firstName + " " + director.lastName
                    }, director.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(casting_title_component, {
                title: "movie_details.cast"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "div",
                sx: {
                    display: "flex",
                    flexWrap: "wrap"
                },
                children: movieInfoProps === null || movieInfoProps === void 0 ? void 0 : (ref17 = movieInfoProps.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.film) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.casts) === null || ref19 === void 0 ? void 0 : ref19.map(function(cast) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(casting_name_with_img, {
                        img: cast.imageUrl || AvatarImg,
                        name: cast.firstName + " " + cast.lastName
                    }, cast.id);
                })
            })
        ]
    });
};
/* harmony default export */ var movie_details_info = (MovieInfo);


/***/ }),

/***/ 15432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ BOOKMARK_NAME_MAX_LENGTH; },
/* harmony export */   "g": function() { return /* binding */ MovieTypesEnum; }
/* harmony export */ });
var MovieTypesEnum;
(function(MovieTypesEnum) {
    MovieTypesEnum["COMING_SOON"] = "COMING_SOON";
    MovieTypesEnum["SHOW_NOW"] = "SHOWING_NOW";
})(MovieTypesEnum || (MovieTypesEnum = {}));
var BOOKMARK_NAME_MAX_LENGTH = 16;


/***/ }),

/***/ 65242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/logic/services/index.ts + 21 modules
var services = __webpack_require__(10029);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 2 modules
var Paper = __webpack_require__(90629);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(16216);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/logic/state/index.ts + 18 modules
var state = __webpack_require__(42125);
// EXTERNAL MODULE: ./src/logic/hooks/index.ts + 27 modules
var hooks = __webpack_require__(7663);
// EXTERNAL MODULE: ./src/components/shared/icon-24.tsx
var icon_24 = __webpack_require__(97946);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(31812);
// EXTERNAL MODULE: ./src/constants/movie-types-enum.ts
var movie_types_enum = __webpack_require__(15432);
// EXTERNAL MODULE: ./src/lotties/muvi_offer_approved.json
var muvi_offer_approved = __webpack_require__(22917);
// EXTERNAL MODULE: ./src/components/offers/offer-badge.tsx + 1 modules
var offer_badge = __webpack_require__(50201);
// EXTERNAL MODULE: ./src/lotties/muvi_offer.json
var muvi_offer = __webpack_require__(45305);
// EXTERNAL MODULE: ./node_modules/@mui/material/Chip/Chip.js + 2 modules
var Chip = __webpack_require__(87918);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
;// CONCATENATED MODULE: ./src/components/movie-details/filters/selected-filters-tags.tsx




var SelectedFiltersTags = function(param) {
    var selectedFilters = param.selectedFilters, handleDeleteSelectedFilter = param.handleDeleteSelectedFilter, sx = param.sx;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: sx,
        children: selectedFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            sx: {
                display: "flex",
                flexWrap: "wrap",
                marginTop: (0,typography/* pxToRem */.Q)(16)
            },
            children: selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.map(function(filter) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                    label: filter.label,
                    sx: {
                        marginInlineEnd: (0,typography/* pxToRem */.Q)(16),
                        marginBottom: (0,typography/* pxToRem */.Q)(16),
                        backgroundColor: theme.palette.primary.light,
                        color: theme.palette.primary.main,
                        height: (0,typography/* pxToRem */.Q)(32),
                        "& .MuiChip-deleteIcon": {
                            fontSize: (0,typography/* pxToRem */.Q)(16)
                        }
                    },
                    deleteIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {}),
                    onDelete: function() {
                        return handleDeleteSelectedFilter({
                            id: filter.id,
                            type: filter.type
                        });
                    }
                }, filter.id);
            })
        })
    });
};
/* harmony default export */ var selected_filters_tags = (SelectedFiltersTags);

// EXTERNAL MODULE: ./src/components/seo/seo.tsx
var seo = __webpack_require__(89183);
// EXTERNAL MODULE: ./src/logic/hooks/use-showtimes-provider.tsx
var use_showtimes_provider = __webpack_require__(85203);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/logic/helpers/index.ts + 6 modules
var helpers = __webpack_require__(80889);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Refresh.js
var Refresh = __webpack_require__(1849);
// EXTERNAL MODULE: ./src/components/shared/customized-circular-progress.tsx
var customized_circular_progress = __webpack_require__(75491);
// EXTERNAL MODULE: ./src/components/shared/image-box-future.tsx
var image_box_future = __webpack_require__(58718);
;// CONCATENATED MODULE: ./src/components/offers/offer-error-badge.tsx









var OfferErrorBadge = function(param) {
    var title = param.title, icon = param.icon, handleAction = param.handleAction, isLoading = param.isLoading, actionTitle = param.actionTitle;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        spacing: 1,
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between",
        sx: {
            width: "100%",
            padding: (0,typography/* pxToRem */.Q)(15),
            marginLeft: 0,
            backgroundColor: theme.palette.lightGrey.main,
            borderRadius: "12px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                justifyContent: "space-between",
                children: [
                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                        img: icon,
                        title: intl.formatMessage({
                            id: "alt.offer_icon"
                        }),
                        objectFit: "contain",
                        sx: (0,_define_property/* default */.Z)({
                            width: "35px",
                            height: "30px",
                            mr: "4px"
                        }, theme.breakpoints.down("mediumDesktop"), {
                            mr: "8px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle2",
                        sx: {
                            fontWeight: 400,
                            color: theme.palette.grey[60]
                        },
                        children: title
                    })
                ]
            }),
            !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                onClick: handleAction,
                sx: {
                    color: theme.palette.primary.main
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Refresh/* default */.Z, {
                        fontSize: "small",
                        sx: {
                            transform: "rotate(310deg)"
                        },
                        fontWeight: 700
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "subtitle2",
                        sx: {
                            fontWeight: 700,
                            color: theme.palette.primary.main
                        },
                        children: actionTitle
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    minWidth: "64px",
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(customized_circular_progress/* default */.Z, {
                    size: 15,
                    thickness: 4
                })
            })
        ]
    });
};
/* harmony default export */ var offer_error_badge = (OfferErrorBadge);

;// CONCATENATED MODULE: ./public/icons/offers/offer-error-badge.svg
var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgOfferErrorBadge = function SvgOfferErrorBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.138 8.465 4.387 35.243a1 1 0 0 0 .861 1.507h31.504a1 1 0 0 0 .861-1.507L21.863 8.465a1 1 0 0 0-1.724 0Z",
    fill: "#E14851",
    stroke: "#E14851",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.5V28",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 31.5,
    r: 1.75,
    fill: "#fff"
  })));
};


/* harmony default export */ var offers_offer_error_badge = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMC4xMzgxIDguNDY1MjlMNC4zODY1MSAzNS4yNDNDMy45OTQzOCAzNS45MDk2IDQuNDc1MDMgMzYuNzUgNS4yNDg0NSAzNi43NUgzNi43NTE2QzM3LjUyNSAzNi43NSAzOC4wMDU3IDM1LjkwOTYgMzcuNjEzNSAzNS4yNDNMMjEuODYyIDguNDY1MjlDMjEuNDc1MyA3LjgwNzk4IDIwLjUyNDcgNy44MDc5OCAyMC4xMzgxIDguNDY1MjlaIiBmaWxsPSIjRTE0ODUxIiBzdHJva2U9IiNFMTQ4NTEiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBkPSJNMjEgMTcuNVYyOCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPGNpcmNsZSBjeD0iMjEiIGN5PSIzMS41IiByPSIxLjc1IiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");
// EXTERNAL MODULE: ./src/logic/types/data-layer-models.ts
var data_layer_models = __webpack_require__(58022);
// EXTERNAL MODULE: ./src/logic/shared/data-layer-events.ts
var data_layer_events = __webpack_require__(60986);
// EXTERNAL MODULE: ./src/constants/regular-expressions.ts
var regular_expressions = __webpack_require__(43902);
// EXTERNAL MODULE: ./src/components/movie-details/showtimes/days-filter.tsx + 2 modules
var days_filter = __webpack_require__(67938);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
;// CONCATENATED MODULE: ./src/components/movie-details/filters/selected-filters.tsx







var SelectedFilters = function(param) {
    var selectedFilters = param.selectedFilters, seeResultsDisabled = param.seeResultsDisabled, handleDeleteSelectedFilter = param.handleDeleteSelectedFilter, clearFilters = param.clearFilters, submitFilters = param.submitFilters;
    var theme = (0,useTheme/* default */.Z)();
    var sx = {
        fontWeight: "700",
        fontSize: (0,typography/* pxToRem */.Q)(28),
        lineHeight: "32px",
        color: theme.palette.grey[90],
        textAlign: "start"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sx), {
                        fontSize: (0,typography/* pxToRem */.Q)(20),
                        marginTop: (0,typography/* pxToRem */.Q)(32)
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "movie_details.selected.filters"
                    })
                }),
                selectedFilters.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    sx: {
                        fontSize: (0,typography/* pxToRem */.Q)(20),
                        fontWeight: "400",
                        marginTop: (0,typography/* pxToRem */.Q)(16),
                        color: theme.palette.grey[50],
                        textAlign: "start"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "movie_details.no.selected.filters"
                    })
                }),
                selectedFilters.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexWrap: "wrap",
                        marginTop: (0,typography/* pxToRem */.Q)(16)
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(selected_filters_tags, {
                            selectedFilters: selectedFilters,
                            handleDeleteSelectedFilter: handleDeleteSelectedFilter
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: (0,typography/* pxToRem */.Q)(24),
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "text",
                                    sx: {
                                        padding: "".concat((0,typography/* pxToRem */.Q)(16), " ").concat((0,typography/* pxToRem */.Q)(20)),
                                        width: (0,typography/* pxToRem */.Q)(180),
                                        color: theme.palette.grey[70]
                                    },
                                    onClick: function() {
                                        return clearFilters();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "movie_details.clear.all"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "contained",
                                    sx: {
                                        padding: "".concat((0,typography/* pxToRem */.Q)(16), " ").concat((0,typography/* pxToRem */.Q)(20)),
                                        width: (0,typography/* pxToRem */.Q)(180),
                                        height: {
                                            tablet: (0,typography/* pxToRem */.Q)(56),
                                            mobile: "56px"
                                        }
                                    },
                                    onClick: function() {
                                        return submitFilters();
                                    },
                                    disabled: seeResultsDisabled,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "movie_details.see.results"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var selected_filters = (SelectedFilters);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(67358);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormGroup/FormGroup.js + 1 modules
var FormGroup = __webpack_require__(53457);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(69368);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
;// CONCATENATED MODULE: ./src/components/movie-details/filters/movie-filters-skeleton.tsx


var FilterSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            justifyContent: "space-between",
            mb: 3
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                sx: {
                    marginInlineEnd: 1
                },
                variant: "rectangular",
                width: 10,
                height: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "rectangular",
                width: "100%",
                height: 10
            })
        ]
    });
};
/* harmony default export */ var movie_filters_skeleton = (FilterSkeleton);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/IndeterminateCheckBox.js
var IndeterminateCheckBox = __webpack_require__(5212);
;// CONCATENATED MODULE: ./src/components/movie-details/filters/cinemas-filter.tsx













var LocationIconBlack = "/icons/movie-details/location-icon-black.svg";
var CinemasFilter = function(param) {
    var typographySx = param.typographySx, cinemas = param.cinemas, selectedCinemasFilter = param.selectedCinemasFilter, isFetchingCinemas = param.isFetchingCinemas, returnSelectedCinemas = param.returnSelectedCinemas, showDisabledFilterMessage = param.showDisabledFilterMessage;
    var ref;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var ref1 = (0,hooks/* useCity */.hA)(), cityId = ref1.cityId, getCity = ref1.getCity;
    var selectedCity = (ref = getCity(cityId)) === null || ref === void 0 ? void 0 : ref.name;
    var handleCinemaChange = function(event) {
        if (checkIfCinemaDisabled(Number(event.target.value))) {
            showDisabledFilterMessage();
            return;
        }
        if (selectedCinemasFilter.indexOf(Number(event.target.value)) < 0) returnSelectedCinemas((0,_to_consumable_array/* default */.Z)(selectedCinemasFilter).concat([
            Number(event.target.value)
        ]));
        else {
            var index = selectedCinemasFilter.indexOf(Number(event.target.value));
            var _selectedCinemasFilter = [];
            Object.assign(_selectedCinemasFilter, selectedCinemasFilter);
            _selectedCinemasFilter.splice(index, 1);
            returnSelectedCinemas((0,_to_consumable_array/* default */.Z)(_selectedCinemasFilter));
        }
    };
    var checkIfCinemaDisabled = function(id) {
        var ref;
        return (ref = cinemas.find(function(cinema) {
            return cinema.id === id;
        })) === null || ref === void 0 ? void 0 : ref.isDisabled;
    };
    var checkIfCinemaChecked = function(id) {
        return selectedCinemasFilter.find(function(cinemaId) {
            return cinemaId === id;
        }) ? true : false;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        defaultExpanded: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                    sx: {
                        color: theme.palette.grey[90]
                    }
                }),
                id: "movie-details-cinemas-filter",
                sx: {
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "transparent"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "div",
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginInlineEnd: "18px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                            img: LocationIconBlack,
                            title: intl.formatMessage({
                                id: "images.title.location"
                            }),
                            objectFit: "contain",
                            sx: {
                                width: "20px",
                                height: "20px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: typographySx,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "cinema"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionDetails/* default */.Z, {
                sx: {
                    margin: (0,typography/* pxToRem */.Q)(24),
                    marginTop: 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, typographySx), {
                            textAlign: "start"
                        }),
                        children: selectedCity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                        children: [
                            !isFetchingCinemas && (cinemas === null || cinemas === void 0 ? void 0 : cinemas.map(function(cinema) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        value: cinema.id,
                                        defaultChecked: checkIfCinemaChecked(cinema.id),
                                        indeterminateIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndeterminateCheckBox/* default */.Z, {}),
                                        indeterminate: checkIfCinemaDisabled(cinema.id),
                                        sx: {
                                            "&.Mui-disabled": {
                                                color: theme.palette.grey[30]
                                            },
                                            "&.MuiCheckbox-indeterminate": {
                                                color: theme.palette.grey[30]
                                            },
                                            "&:hover": {
                                                backgroundColor: "transparent"
                                            }
                                        },
                                        onChange: handleCinemaChange
                                    }),
                                    label: cinema.name
                                }, cinema.id);
                            })),
                            isFetchingCinemas && (0,_to_consumable_array/* default */.Z)(Array((cinemas === null || cinemas === void 0 ? void 0 : cinemas.length) || 5)).map(function(i, _i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(movie_filters_skeleton, {}, _i);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var cinemas_filter = (CinemasFilter);

// EXTERNAL MODULE: ./node_modules/@mui/material/Tooltip/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(34386);
;// CONCATENATED MODULE: ./src/components/movie-details/filters/experiences-filter.tsx












var EmptyExperienceImgCard = "/icons/cinema/emptyExperienceImgCard.svg";
var ExperienceIconBlack = "/icons/movie-details/experience-icon-black.svg";
var ExperiencesFilter = function(param) {
    var typographySx = param.typographySx, experiences = param.experiences, selectedExperiencesFilter = param.selectedExperiencesFilter, isFetchingExperiences = param.isFetchingExperiences, returnSelectedExperiences = param.returnSelectedExperiences, showDisabledFilterMessage = param.showDisabledFilterMessage;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var setDialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.setDialog;
    }, shallow/* default */.Z);
    var handleExperienceChange = function(event) {
        if (checkIfExperienceDisabled(Number(event.target.value))) {
            showDisabledFilterMessage();
            return;
        }
        if (selectedExperiencesFilter.indexOf(Number(event.target.value)) < 0) returnSelectedExperiences((0,_to_consumable_array/* default */.Z)(selectedExperiencesFilter).concat([
            Number(event.target.value), 
        ]));
        else {
            var index = selectedExperiencesFilter.indexOf(Number(event.target.value));
            var _selectedExperiencesFilter = [];
            Object.assign(_selectedExperiencesFilter, selectedExperiencesFilter);
            _selectedExperiencesFilter.splice(index, 1);
            returnSelectedExperiences((0,_to_consumable_array/* default */.Z)(_selectedExperiencesFilter));
        }
    };
    var checkIfExperienceDisabled = function(id) {
        var ref;
        return (ref = experiences.find(function(experience) {
            return experience.id === id;
        })) === null || ref === void 0 ? void 0 : ref.isDisabled;
    };
    var checkIfExperienceChecked = function(id) {
        return !!selectedExperiencesFilter.find(function(cinemaId) {
            return cinemaId === id;
        });
    };
    var FilterItem = function(param) {
        var experience = param.experience;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    value: experience.id,
                    defaultChecked: checkIfExperienceChecked(experience.id),
                    indeterminateIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IndeterminateCheckBox/* default */.Z, {}),
                    indeterminate: checkIfExperienceDisabled(experience.id),
                    sx: {
                        "&.Mui-disabled": {
                            color: theme.palette.grey[30]
                        },
                        "&.MuiCheckbox-indeterminate": {
                            color: theme.palette.grey[30]
                        },
                        "&:hover": {
                            backgroundColor: "transparent"
                        }
                    },
                    onChange: function(e) {
                        return handleExperienceChange(e);
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                            img: experience.logo || EmptyExperienceImgCard,
                            title: experience.logoAlt || (experience === null || experience === void 0 ? void 0 : experience.name),
                            layout: "intrinsic",
                            objectFit: "contain",
                            width: "794px",
                            height: "397px",
                            sx: {
                                minWidth: {
                                    mobile: "92px",
                                    tablet: (0,typography/* pxToRem */.Q)(92)
                                }
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                            title: experience.description,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    paddingInlineStart: (0,typography/* pxToRem */.Q)(22),
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        marginTop: (0,typography/* pxToRem */.Q)(22),
                                        textAlign: "start"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    fontSize: {
                                                        mobile: "14px",
                                                        tablet: (0,typography/* pxToRem */.Q)(16)
                                                    },
                                                    color: theme.palette.grey[50],
                                                    fontWeight: 400,
                                                    fontFamily: theme.palette.typography.font.regular,
                                                    WebkitLineClamp: "4",
                                                    lineHeight: "24px",
                                                    display: "-webkit-box",
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                },
                                                children: experience.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                sx: {
                                                    color: theme.palette.primary.main,
                                                    fontWeight: 700,
                                                    fontSize: (0,typography/* pxToRem */.Q)(16),
                                                    lineHeight: "24px",
                                                    cursor: "pointer"
                                                },
                                                onClick: function() {
                                                    return setDialog({
                                                        wrapper: true,
                                                        isExperienceInfoDialog: true,
                                                        experienceInfoDialogPayload: experience
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "movie_details.read.more"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
        defaultExpanded: true,
        sx: {
            "&.Mui-expanded": {
                margin: 0
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionSummary/* default */.Z, {
                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                    sx: {
                        color: theme.palette.grey[90]
                    }
                }),
                id: "movie-details-experiences-filter",
                sx: {
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "transparent"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "div",
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginInlineEnd: "18px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                            img: ExperienceIconBlack,
                            title: intl.formatMessage({
                                id: "alt.experience_con"
                            }),
                            objectFit: "contain",
                            sx: {
                                width: "20px",
                                height: "18px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: typographySx,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "experience"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                sx: {
                    margin: (0,typography/* pxToRem */.Q)(24),
                    marginTop: 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                    sx: {
                        mt: 3
                    },
                    children: [
                        !isFetchingExperiences && (experiences === null || experiences === void 0 ? void 0 : experiences.map(function(experience) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterItem, {
                                    experience: experience
                                }),
                                label: ""
                            }, experience.id);
                        })),
                        isFetchingExperiences && (0,_to_consumable_array/* default */.Z)(Array((experiences === null || experiences === void 0 ? void 0 : experiences.length) || 5)).map(function(i, _i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(movie_filters_skeleton, {}, _i);
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var experiences_filter = (ExperiencesFilter);

;// CONCATENATED MODULE: ./src/components/movie-details/filters/movie-filters.tsx














var NoFilters = "/icons/movie-finder/empty-filter-icon.svg";
var MovieFilters = function(param) {
    var submitFilters = param.submitFilters, removeSelectedFilter = param.removeSelectedFilter, handleClearFilters = param.handleClearFilters;
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,state/* useMovieDetailsState */.DQ)(function(s) {
        return [
            s.movieCinemasFilter,
            s.selectedCinemasFilter,
            s.movieExperiencesFilter,
            s.selectedExperiencesFilter,
            s.selectedFilters,
            s.isFetchingCinemas,
            s.isFetchingExperiences,
            s.filmCinemas,
            s.seeResultsDisabled,
            s.setSelectedCinemasFilter,
            s.setSelectedExperiencesFilter,
            s.isOfferApplied,
            s.isThereAtLeastOneAvailableShowTime, 
        ];
    }, shallow/* default */.Z), 13), movieCinemasFilter = ref2[0], selectedCinemasFilter = ref2[1], movieExperiencesFilter = ref2[2], selectedExperiencesFilter = ref2[3], selectedFilters = ref2[4], isFetchingCinemas = ref2[5], isFetchingExperiences = ref2[6], filmCinemas = ref2[7], seeResultsDisabled = ref2[8], setSelectedCinemasFilter = ref2[9], setSelectedExperiencesFilter = ref2[10], isOfferApplied = ref2[11], isThereAtLeastOneAvailableShowTime = ref2[12];
    var EmptyMsg = /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
        id: !isThereAtLeastOneAvailableShowTime ? "movie_details.no_filters_can_be_Selected" : "movie_details.offer.no_filters_can_be_Selected"
    });
    var theme = (0,useTheme/* default */.Z)();
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var intl = (0,useIntl/* default */.Z)();
    var dividerSx = {
        backgroundColor: theme.palette.grey[20]
    };
    var typographySx = {
        color: theme.palette.grey[90],
        fontWeight: 400,
        fontSize: (0,typography/* pxToRem */.Q)(20),
        lineHeight: "30px"
    };
    var showDisabledFilterMessage = function() {
        setSnack({
            isOpen: true,
            message: intl.formatMessage({
                id: "movie_details.this_option_is_not_available"
            }),
            type: "info"
        });
    };
    var sx = {
        fontWeight: "700",
        fontSize: (0,typography/* pxToRem */.Q)(28),
        lineHeight: "32px",
        color: theme.palette.grey[90],
        textAlign: "start"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            boxShadow: "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    padding: (0,typography/* pxToRem */.Q)(24),
                    paddingTop: {
                        mobile: (0,typography/* pxToRem */.Q)(30),
                        desktop: (0,typography/* pxToRem */.Q)(54)
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sx), {
                            fontSize: (0,typography/* pxToRem */.Q)(28)
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "movie_details.filters"
                        })
                    }),
                    isThereAtLeastOneAvailableShowTime && (filmCinemas === null || filmCinemas === void 0 ? void 0 : (ref = filmCinemas.cinemas) === null || ref === void 0 ? void 0 : ref.length) !== 0 && !isOfferApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(selected_filters, {
                        selectedFilters: selectedFilters,
                        seeResultsDisabled: seeResultsDisabled,
                        handleDeleteSelectedFilter: removeSelectedFilter,
                        clearFilters: handleClearFilters,
                        submitFilters: submitFilters
                    })
                ]
            }),
            isThereAtLeastOneAvailableShowTime && (filmCinemas === null || filmCinemas === void 0 ? void 0 : (ref1 = filmCinemas.cinemas) === null || ref1 === void 0 ? void 0 : ref1.length) !== 0 && !isOfferApplied ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: dividerSx
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(cinemas_filter, {
                        typographySx: typographySx,
                        cinemas: movieCinemasFilter === null || movieCinemasFilter === void 0 ? void 0 : movieCinemasFilter.cinemas,
                        selectedCinemasFilter: selectedCinemasFilter.map(function(param) {
                            var id = param.id;
                            return id;
                        }),
                        isFetchingCinemas: isFetchingCinemas,
                        returnSelectedCinemas: function(cinemasIds) {
                            return setSelectedCinemasFilter(cinemasIds.map(function(id) {
                                return {
                                    id: id,
                                    type: "cinema"
                                };
                            }));
                        },
                        showDisabledFilterMessage: showDisabledFilterMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        sx: dividerSx
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(experiences_filter, {
                        typographySx: typographySx,
                        experiences: movieExperiencesFilter === null || movieExperiencesFilter === void 0 ? void 0 : movieExperiencesFilter.experiences,
                        selectedExperiencesFilter: selectedExperiencesFilter.map(function(param) {
                            var id = param.id;
                            return id;
                        }),
                        isFetchingExperiences: isFetchingExperiences,
                        returnSelectedExperiences: function(experiencesIds) {
                            return setSelectedExperiencesFilter(experiencesIds.map(function(id) {
                                return {
                                    id: id,
                                    type: "experience"
                                };
                            }));
                        },
                        showDisabledFilterMessage: showDisabledFilterMessage
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    height: "50vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            marginTop: (0,typography/* pxToRem */.Q)(80),
                            marginBottom: (0,typography/* pxToRem */.Q)(24),
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                            img: NoFilters,
                            title: intl.formatMessage({
                                id: "alt.empty_filters"
                            }),
                            objectFit: "contain",
                            sx: {
                                width: "74px",
                                height: "84px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        sx: {
                            color: theme.palette.grey[50],
                            fontWeight: 400,
                            fontSize: (0,typography/* pxToRem */.Q)(20),
                            lineHeight: "30px",
                            textAlign: "center",
                            padding: "10px"
                        },
                        children: EmptyMsg
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var movie_filters = (MovieFilters);

// EXTERNAL MODULE: ./node_modules/@alpha.apps/react-common/dist/index.js + 6 modules
var dist = __webpack_require__(46080);
// EXTERNAL MODULE: ./src/components/experience/experience-card.tsx
var experience_card = __webpack_require__(69464);
;// CONCATENATED MODULE: ./src/components/movie-details/showtimes/experience-collapse-list.tsx














var LocationIcon = "/icons/shared/location-icon-blue.svg";
var ExperienceCollapseList = function(param) {
    var movieId = param.movieId, cinemas = param.cinemas, loadTheLeftCinemas = param.loadTheLeftCinemas, callOnFilmHasBeenStarted = param.callOnFilmHasBeenStarted, showTimeDate = param.showTimeDate;
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,react.useState)(0), activeAccordion = ref[0], setExpanded = ref[1];
    var selectedCinemasHomePage = (0,state/* useCinemas */.wj)(function(s) {
        return s.selectedCinemas;
    }, shallow/* default */.Z);
    var selectedCinemas = (0,hooks/* useCinema */.Z8)().selectedCinemas;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,state/* useMovieDetailsState */.DQ)(function(s) {
        return [
            s.isFetching,
            s.isFilterMode,
            s.showMoreBtn
        ];
    }, shallow/* default */.Z), 3), isFetching = ref1[0], isFilterMode = ref1[1], showMoreBtn = ref1[2];
    var handleChange = function(panelNumber) {
        return function() {
            if (activeAccordion === panelNumber) setExpanded(null);
            else setExpanded(panelNumber);
        };
    };
    var checkIsAllCinemasSelected = function() {
        // 0 is the is of all selected cinemas
        var index = selectedCinemasHomePage.findIndex(function(id) {
            return id === 0;
        });
        return index !== -1;
    };
    (0,react.useEffect)(function() {
        if ((0,dist/* isString */.HD)(showTimeDate)) {
            setExpanded(0);
        }
    }, [
        showTimeDate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            paddingInline: (0,typography/* pxToRem */.Q)(30)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [
                !isFetching && (cinemas === null || cinemas === void 0 ? void 0 : cinemas.map(function(cinema, index) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                        expanded: activeAccordion === index,
                        onChange: handleChange(index),
                        sx: {
                            marginTop: (0,typography/* pxToRem */.Q)(40)
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionSummary/* default */.Z, {
                                expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                                    sx: {
                                        color: theme.palette.secondary.main
                                    }
                                }),
                                id: "cinema-collapse-".concat(index),
                                sx: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        component: "div",
                                        sx: {
                                            width: (0,typography/* pxToRem */.Q)(36),
                                            height: (0,typography/* pxToRem */.Q)(36),
                                            backgroundColor: theme.palette.common.white,
                                            borderRadius: "9px",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            marginInlineEnd: "16px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                            img: LocationIcon,
                                            title: intl.formatMessage({
                                                id: "images.title.location"
                                            }),
                                            objectFit: "contain",
                                            sx: {
                                                width: "15px",
                                                height: "18px"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            color: theme.palette.grey[80],
                                            fontWeight: 400,
                                            fontSize: (0,typography/* pxToRem */.Q)(20),
                                            lineHeight: "30px"
                                        },
                                        children: cinema.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                children: (ref = cinema.experiences) === null || ref === void 0 ? void 0 : ref.map(function(experience, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(experience_card/* default */.Z, {
                                        movieId: movieId,
                                        experience: experience,
                                        index: index,
                                        callOnFilmHasBeenStarted: callOnFilmHasBeenStarted
                                    }, experience.id);
                                })
                            })
                        ]
                    }, cinema.id);
                })),
                (cinemas === null || cinemas === void 0 ? void 0 : cinemas.length) === 0 && !isFetching && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                marginTop: (0,typography/* pxToRem */.Q)(80),
                                marginBottom: (0,typography/* pxToRem */.Q)(24),
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                img: "/icons/movie-details/no-showtimes-available.svg",
                                title: intl.formatMessage({
                                    id: "alt.no_show_time_available"
                                }),
                                objectFit: "contain",
                                sx: {
                                    width: "382px",
                                    height: "282px"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                color: theme.palette.grey[50],
                                fontWeight: 400,
                                fontSize: (0,typography/* pxToRem */.Q)(20),
                                lineHeight: "30px",
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "movies.there.is.no.showtimes"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: (0,typography/* pxToRem */.Q)(52)
                    },
                    children: [
                        showMoreBtn && !isFetching && !isFilterMode && selectedCinemas.length !== 0 && !checkIsAllCinemasSelected() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "text",
                            fullWidth: false,
                            sx: {
                                fontSize: (0,typography/* pxToRem */.Q)(16),
                                fontWeight: "700",
                                color: theme.palette.grey[70],
                                marginTop: (0,typography/* pxToRem */.Q)(58)
                            },
                            onClick: function() {
                                return loadTheLeftCinemas();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "movie_details.show.more.cinemas"
                            })
                        }),
                        isFetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(customized_circular_progress/* default */.Z, {
                            size: 40,
                            thickness: 4
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var experience_collapse_list = (ExperienceCollapseList);

// EXTERNAL MODULE: ./src/components/shared/close-button.tsx
var close_button = __webpack_require__(4997);
// EXTERNAL MODULE: ./src/components/shared/movie-details-info.tsx + 4 modules
var movie_details_info = __webpack_require__(2155);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/pages/movies/[slug]/index.tsx

































var MovieBanner = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(371), __webpack_require__.e(4271)]).then(__webpack_require__.bind(__webpack_require__, 4271));
}, {
    ssr: false
});







var filterIcon = "/icons/shared/filter.svg";
var BillIcon = "/icons/movie-details/bill-white-icon.svg";
var ComingSoonIcon = "/icons/movie-details/coming-soon.svg";
var MovieDetails = function(param) {
    var path = param.path, movieLocations = param.movieLocations, serverMovie = param.serverMovie, serverMovieCinemasFilter = param.serverMovieCinemasFilter, serverMovieExperiencesFilter = param.serverMovieExperiencesFilter;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var theme = (0,useTheme/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var intl = (0,useIntl/* default */.Z)();
    var user = (0,state/* useAuth */.aC)(function(s) {
        return s.user;
    }, shallow/* default */.Z);
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref10 = (0,hooks/* useCity */.hA)(), browserCityId = ref10.cityId, getCity = ref10.getCity;
    var cityId = +router.query.cityId || browserCityId;
    var ref11 = (0,hooks/* useMovieDetails */.Bm)({
        serverMovie: serverMovie,
        serverMovieCinemasFilter: serverMovieCinemasFilter,
        serverMovieExperiencesFilter: serverMovieExperiencesFilter
    }), clientMovie = ref11.clientMovie, refetch = ref11.refetch, handleSubmitFilters = ref11.handleSubmitFilters, handleMoviePageDeleteOffer = ref11.handleMoviePageDeleteOffer, handleClickShowtime = ref11.handleClickShowtime, handleClearFilters = ref11.handleClearFilters, handleLoadTheLeftCinemas = ref11.handleLoadTheLeftCinemas, callOnFilmHasBeenStarted = ref11.callOnFilmHasBeenStarted, removeSelectedFilter = ref11.removeSelectedFilter;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,state/* useMovieDetailsState */.DQ)(function(s) {
        return [
            s.offer,
            s.filmCinemas,
            s.showTimeDate,
            s.setShowTimeDate,
            s.setFirstEnabledDay,
            s.selectedFilters,
            s.isFiltersDrawerOpen,
            s.setIsFiltersDrawerOpen,
            s.setIsSeeResultsDisabled,
            s.isOfferApplied,
            s.isThereAtLeastOneAvailableShowTime,
            s.isFetching,
            s.movieHasOffers,
            s.hasOfferError,
            s.hasOfferLoading, 
        ];
    }, shallow/* default */.Z), 15), offer = ref12[0], filmCinemas = ref12[1], showTimeDate = ref12[2], setShowTimeDate = ref12[3], setFirstEnabledDay = ref12[4], selectedFilters = ref12[5], isFiltersDrawerOpen = ref12[6], setIsFiltersDrawerOpen = ref12[7], setIsSeeResultsDisabled = ref12[8], isOfferApplied = ref12[9], isThereAtLeastOneAvailableShowTime = ref12[10], isFetching = ref12[11], movieHasOffers = ref12[12], hasOfferError = ref12[13], hasOfferLoading = ref12[14];
    var movie = clientMovie || serverMovie;
    var isSelectedDateHasOffers = movieHasOffers;
    // const isSelectedDateHasOffers = filmCinemas?.hasOffers;
    var handleOpenFiltersDrawer = function() {
        return setIsFiltersDrawerOpen(true);
    };
    var handleCloseFiltersDrawer = function() {
        return setIsFiltersDrawerOpen(false);
    };
    var ref13 = (0,hooks/* useOfferHandler */.P0)(offer === null || offer === void 0 ? void 0 : offer.offer), isBankOffer = ref13.isBankOffer, offerTitle = ref13.offerTitle, handleDeleteOffer = ref13.handleDeleteOffer;
    var Item = (0,styled/* default */.ZP)(Paper/* default */.Z)(function(param) {
        var theme = param.theme;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : theme.palette.common.white
        }, theme.typography.body2), {
            padding: theme.spacing(1),
            textAlign: "center",
            color: theme.palette.text.secondary
        });
    });
    var _useFilmRemindMe = (0,services/* useFilmRemindMe */.rx)({}, {
        onSuccess: function() {
            return queryClient.invalidateQueries([
                {
                    url: services/* filmsUrl */.Wt
                }, 
            ]);
        }
    });
    var remindMe = function() {
        _useFilmRemindMe.safeMutateAsync({
            query: {
                id: movie.film.id,
                customUrl: "add-reminder"
            }
        }, {
            onSuccess: function() {
                setSnack({
                    isOpen: true,
                    message: "my_booking.booking_details.add_reminder.success",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                        icon: BillIcon,
                        title: "alt.bill_icon"
                    }),
                    type: "info"
                });
                refetch();
            },
            onError: function(error) {
                if (axios_default().isAxiosError(error)) {
                    setSnack({
                        isOpen: true,
                        message: "global.someThingWentWrong",
                        type: "error"
                    });
                }
            }
        });
    };
    var _useRemoveReminder = (0,services/* useRemoveReminder */.VU)({}, {
        onSuccess: function() {
            return queryClient.invalidateQueries([
                {
                    url: services/* filmsUrl */.Wt
                }, 
            ]);
        }
    });
    var removeReminder = function() {
        _useRemoveReminder.safeMutateAsync({
            query: {
                id: movie.film.id,
                customUrl: "remove-reminder"
            }
        }, {
            onSuccess: function() {
                setSnack({
                    isOpen: true,
                    message: "movie_details.remove.notification.success",
                    type: "success"
                });
                refetch();
            },
            onError: function(error) {
                if (axios_default().isAxiosError(error)) {
                    setSnack({
                        isOpen: true,
                        message: "global.someThingWentWrong",
                        type: "info"
                    });
                }
            }
        });
    };
    var onRouteChangeStart = (0,react.useCallback)(function() {
        return null;
    }, []);
    var onRouteChangeComplete = (0,react.useCallback)(function(nextPath) {
        if (!regular_expressions/* moviePageRegExp.test */.Vl.test(nextPath) && !regular_expressions/* bookingPageRegExp.test */.Jc.test(nextPath) && !regular_expressions/* checkoutPageRegExp.test */.Ou.test(nextPath)) {
            handleDeleteOffer();
            router.events.off("routeChangeComplete", onRouteChangeComplete);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        handleDeleteOffer
    ]);
    var onBeforeUnload = (0,react.useCallback)(function() {
        return null;
    }, []);
    (0,hooks/* useRouteChangeHandler */.Xo)({
        onRouteChangeStart: onRouteChangeStart,
        onRouteChangeComplete: onRouteChangeComplete,
        onBeforeUnload: onBeforeUnload
    });
    var triggerDataLayerViewItemEvent = function() {
        var ref;
        var _film = movie.film, id = _film.id, title = _film.title, genres = _film.genres, experiances = _film.experiances, cinemas = _film.cinemas, movieLang = _film.movieLang;
        var data = {
            event: data_layer_models/* EventTypes.VIEW_ITEM */.G.VIEW_ITEM,
            ecommerce: {
                currency: data_layer_models/* Currency.SAR */.F.SAR,
                value: 0,
                items: [
                    {
                        item_id: id.toString(),
                        item_name: title,
                        item_brand: genres.map(function(genre) {
                            return genre.name;
                        }).join(","),
                        item_category: experiances.map(function(experiance) {
                            return experiance.name;
                        }).join(","),
                        item_category2: "",
                        item_list_id: "Movie Details",
                        item_list_name: "Movie Details",
                        location: (ref = getCity(cityId)) === null || ref === void 0 ? void 0 : ref.name,
                        mall: cinemas.map(function(cinema) {
                            return cinema.name;
                        }).join(","),
                        price: 0,
                        quantity: 1,
                        movie_language: movieLang
                    }, 
                ]
            }
        };
        (0,data_layer_events/* triggerGAEvent */.S)(data, true);
    };
    (0,react.useEffect)(function() {
        triggerDataLayerViewItemEvent();
    }, []);
    var _obj, _obj1, _obj2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!movie && /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: (movie === null || movie === void 0 ? void 0 : (ref = movie.film) === null || ref === void 0 ? void 0 : ref.titleTag) || (movie === null || movie === void 0 ? void 0 : (ref1 = movie.film) === null || ref1 === void 0 ? void 0 : ref1.title),
                canonical: movie === null || movie === void 0 ? void 0 : (ref2 = movie.film) === null || ref2 === void 0 ? void 0 : ref2.canonicalURL,
                pagePath: path.slice(0, 3) === "/en" || path.slice(0, 3) === "/ar" ? path : "".concat(router.locale).concat(path),
                description: (movie === null || movie === void 0 ? void 0 : (ref3 = movie.film) === null || ref3 === void 0 ? void 0 : ref3.descriptionTag) || (movie === null || movie === void 0 ? void 0 : (ref4 = movie.film) === null || ref4 === void 0 ? void 0 : ref4.synopsis),
                image: movie === null || movie === void 0 ? void 0 : (ref5 = movie.film) === null || ref5 === void 0 ? void 0 : ref5.image,
                components: function() {
                    return (0,helpers/* buildEventSchemaComponent */.SL)(movie === null || movie === void 0 ? void 0 : movie.film, movieLocations);
                },
                noFollow: movie === null || movie === void 0 ? void 0 : (ref6 = movie.film) === null || ref6 === void 0 ? void 0 : ref6.hasFollow,
                noIndex: movie === null || movie === void 0 ? void 0 : (ref7 = movie.film) === null || ref7 === void 0 ? void 0 : ref7.hasIndex
            }),
            (movie === null || movie === void 0 ? void 0 : movie.film) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MovieBanner, {
                data: movie
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: (_obj = {
                    flexGrow: 1,
                    px: (0,typography/* pxToRem */.Q)(128),
                    pt: (0,typography/* pxToRem */.Q)(52),
                    mb: (0,typography/* pxToRem */.Q)(77)
                }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("laptop"), {
                    px: "50px"
                }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("tablet"), {
                    px: "16px"
                }), _obj),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    children: [
                        (movie === null || movie === void 0 ? void 0 : (ref8 = movie.film) === null || ref8 === void 0 ? void 0 : ref8.type) !== movie_types_enum/* MovieTypesEnum.SHOW_NOW */.g.SHOW_NOW && !(movie === null || movie === void 0 ? void 0 : movie.film.isAdvancedBooking) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            mobile: 12,
                            tablet: 12,
                            laptop: 8,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                component: "div",
                                sx: (_obj1 = {
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }, (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.up("tablet"), {
                                    mt: (0,typography/* pxToRem */.Q)(266)
                                }), (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.down("tablet"), {
                                    mt: (0,typography/* pxToRem */.Q)(100)
                                }), _obj1),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                        img: ComingSoonIcon,
                                        title: intl.formatMessage({
                                            id: "images.title.coming_soon"
                                        }),
                                        objectFit: "contain",
                                        sx: (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, theme.breakpoints.down("laptop"), {
                                            width: "220px",
                                            height: "156px"
                                        }), (0,_define_property/* default */.Z)(_obj2, "width", (0,typography/* pxToRem */.Q)(637)), (0,_define_property/* default */.Z)(_obj2, "height", (0,typography/* pxToRem */.Q)(451)), _obj2)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "subtitle1",
                                        component: "div",
                                        sx: (0,_define_property/* default */.Z)({
                                            fontSize: (0,typography/* pxToRem */.Q)(24),
                                            textAlign: "center",
                                            color: theme.palette.grey[50],
                                            mt: (0,typography/* pxToRem */.Q)(52),
                                            mb: (0,typography/* pxToRem */.Q)(40)
                                        }, theme.breakpoints.down("laptop"), {
                                            mt: "16px",
                                            mb: "22px"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "movie_details.movie_coming_soon"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "movie_details.miss_to_watch"
                                            })
                                        ]
                                    }),
                                    user && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                        variant: "contained",
                                        sx: {
                                            fontSize: "16px",
                                            width: "187px"
                                        },
                                        onClick: function() {
                                            return (movie === null || movie === void 0 ? void 0 : movie.film.hasReminder) ? removeReminder() : remindMe();
                                        },
                                        loading: _useFilmRemindMe.isLoading,
                                        children: (movie === null || movie === void 0 ? void 0 : movie.film.hasReminder) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "movie_details.remove.notification"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                            id: "movie_details.remind_me"
                                        })
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    mobile: 12,
                                    mediumTablet: 6,
                                    laptop: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                        sx: {
                                            p: 0,
                                            display: {
                                                mobile: "none",
                                                mediumTablet: "block"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(movie_filters, {
                                            removeSelectedFilter: removeSelectedFilter,
                                            handleClearFilters: handleClearFilters,
                                            submitFilters: function() {
                                                return handleSubmitFilters();
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    mobile: 12,
                                    mediumTablet: 6,
                                    laptop: 5,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(days_filter/* default */.Z, {
                                                    sessionsDate: movie === null || movie === void 0 ? void 0 : movie.sessionsDates,
                                                    showTimeDate: showTimeDate,
                                                    returnFirstEnabledDate: setFirstEnabledDay,
                                                    selectDate: function(date) {
                                                        setShowTimeDate(date);
                                                        setIsSeeResultsDisabled(true);
                                                    }
                                                }),
                                                isSelectedDateHasOffers && !isOfferApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        marginY: 2,
                                                        marginX: 2.75
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: {
                                                            pathname: "/movies/".concat(movie.film.uniqueName, "/offers"),
                                                            query: {
                                                                date: showTimeDate,
                                                                cityId: cityId
                                                            }
                                                        },
                                                        passHref: true,
                                                        prefetch: false,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                            component: "a",
                                                            sx: {
                                                                width: "100%"
                                                            },
                                                            id: "apply-offer",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_badge/* default */.Z, {
                                                                lottie: muvi_offer,
                                                                title: intl.formatMessage({
                                                                    id: "offer.banner.title"
                                                                }),
                                                                subTitle: intl.formatMessage({
                                                                    id: "offer.banner.subtitle"
                                                                }),
                                                                styles: {
                                                                    subTitle: {
                                                                        color: theme.palette.grey[60]
                                                                    }
                                                                }
                                                            })
                                                        })
                                                    })
                                                }),
                                                hasOfferError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        margin: 2.75
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_error_badge, {
                                                        icon: offers_offer_error_badge,
                                                        title: intl.formatMessage({
                                                            id: "offer.error.title"
                                                        }),
                                                        actionTitle: intl.formatMessage({
                                                            id: "offer.error.reload"
                                                        }),
                                                        handleAction: function() {
                                                            return queryClient.invalidateQueries([
                                                                {
                                                                    url: "offers/check-film"
                                                                }, 
                                                            ]);
                                                        },
                                                        isLoading: hasOfferLoading
                                                    })
                                                }),
                                                isOfferApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    sx: {
                                                        marginY: 2
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_badge/* default */.Z, {
                                                        lottie: muvi_offer_approved,
                                                        title: intl.formatMessage({
                                                            id: "offer.banner.applied.title"
                                                        }),
                                                        onDelete: handleMoviePageDeleteOffer,
                                                        subTitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                            component: "span",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    component: "span",
                                                                    children: offerTitle
                                                                }),
                                                                isBankOffer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    component: "span",
                                                                    children: intl.formatMessage({
                                                                        id: "offer.banner.applied.subtitle"
                                                                    }, {
                                                                        bankName: offer === null || offer === void 0 ? void 0 : (ref9 = offer.offer) === null || ref9 === void 0 ? void 0 : ref9.bankName
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        styles: {
                                                            subTitle: {
                                                                color: theme.palette.grey[60]
                                                            }
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                    sx: {
                                                        px: (0,typography/* pxToRem */.Q)(30),
                                                        marginBottom: (0,typography/* pxToRem */.Q)(45)
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                            direction: "row",
                                                            justifyContent: "space-between",
                                                            children: [
                                                                (filmCinemas === null || filmCinemas === void 0 ? void 0 : filmCinemas.cinemas.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    id: "movie-shows",
                                                                    sx: {
                                                                        color: theme.palette.common.black,
                                                                        fontSize: (0,typography/* pxToRem */.Q)(20),
                                                                        fontWeight: 700,
                                                                        lineHeight: (0,typography/* pxToRem */.Q)(30),
                                                                        marginTop: (0,typography/* pxToRem */.Q)(45)
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "movie.shows"
                                                                    })
                                                                }),
                                                                !isOfferApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                                    sx: {
                                                                        display: {
                                                                            mobile: "block",
                                                                            mediumTablet: "none"
                                                                        }
                                                                    },
                                                                    onClick: function() {
                                                                        return handleOpenFiltersDrawer();
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                                                        img: filterIcon,
                                                                        title: intl.formatMessage({
                                                                            id: "alt.filter_icon"
                                                                        }),
                                                                        objectFit: "contain",
                                                                        width: "40px",
                                                                        height: "40px",
                                                                        sx: {
                                                                            width: "40px",
                                                                            height: "40px"
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                            direction: "row",
                                                            spacing: 2,
                                                            sx: {
                                                                marginBottom: 2,
                                                                display: {
                                                                    mobile: "flex",
                                                                    tablet: "none"
                                                                }
                                                            },
                                                            children: [
                                                                (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length) > 0 && !isOfferApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    size: "small",
                                                                    variant: "lightGrey",
                                                                    sx: {
                                                                        mt: "1rem",
                                                                        height: "20px",
                                                                        borderRadius: "30px",
                                                                        px: "12px",
                                                                        py: "4px",
                                                                        fontSize: (0,typography/* pxToRem */.Q)(16)
                                                                    },
                                                                    onClick: handleClearFilters,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                        id: "movie_details.clear.filters"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(selected_filters_tags, {
                                                                    sx: {
                                                                        display: {
                                                                            mobile: "block",
                                                                            tablet: "none"
                                                                        }
                                                                    },
                                                                    selectedFilters: selectedFilters,
                                                                    handleDeleteSelectedFilter: removeSelectedFilter
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                !isThereAtLeastOneAvailableShowTime && !isFetching && !(filmCinemas === null || filmCinemas === void 0 ? void 0 : filmCinemas.cinemas) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                            sx: {
                                                                marginTop: (0,typography/* pxToRem */.Q)(80),
                                                                marginBottom: (0,typography/* pxToRem */.Q)(24),
                                                                display: "flex",
                                                                justifyContent: "center"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                                                img: "/icons/movie-details/no-showtimes-available.svg",
                                                                title: intl.formatMessage({
                                                                    id: "alt.no_show_time_available"
                                                                }),
                                                                objectFit: "contain",
                                                                sx: {
                                                                    width: "382px",
                                                                    height: "282px"
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            sx: {
                                                                color: theme.palette.grey[50],
                                                                fontWeight: 400,
                                                                fontSize: (0,typography/* pxToRem */.Q)(20),
                                                                lineHeight: "30px",
                                                                textAlign: "center"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                id: "movies.there.is.no.showtimes.remove.filters"
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(use_showtimes_provider/* ShowtimesProvider */.I, {
                                                    handleClickShowtime: handleClickShowtime,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(experience_collapse_list, {
                                                        movieId: movie.film.id,
                                                        cinemas: filmCinemas === null || filmCinemas === void 0 ? void 0 : filmCinemas.cinemas,
                                                        loadTheLeftCinemas: handleLoadTheLeftCinemas,
                                                        callOnFilmHasBeenStarted: callOnFilmHasBeenStarted,
                                                        showTimeDate: showTimeDate
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                                            anchor: "bottom",
                                            open: isFiltersDrawerOpen,
                                            onClose: handleCloseFiltersDrawer,
                                            sx: {
                                                ".MuiDrawer-paper": {
                                                    height: "100%"
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    component: "div",
                                                    sx: {
                                                        py: "10px"
                                                    },
                                                    onClick: function() {
                                                        return handleCloseFiltersDrawer();
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                                                        sx: {
                                                            position: "static"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(movie_filters, {
                                                        removeSelectedFilter: removeSelectedFilter,
                                                        handleClearFilters: function() {
                                                            return handleClearFilters();
                                                        },
                                                        submitFilters: function() {
                                                            handleSubmitFilters();
                                                            handleCloseFiltersDrawer();
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            mobile: 12,
                            mediumTablet: 6,
                            laptop: 4,
                            sx: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("laptop"), {
                                display: "none"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(movie_details_info/* default */.C, {
                                data: movie
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (MovieDetails);


/***/ }),

/***/ 22917:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"nm":"Pre-comp 1","ddd":0,"h":573,"w":573,"meta":{"a":"AlphaApps","g":"LottieFiles AE 3.2.2"},"layers":[{"ty":4,"nm":"Tick","sr":1,"st":0,"op":749.916583249917,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.94,7.694,0],"ix":1},"s":{"a":0,"k":[527.525,527.525,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[446.675,440.184,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[-0.633,-0.626],[0.633,-0.626],[0,0],[0,0],[-0.633,0.626],[-0.633,-0.627]],"o":[[0,0],[0.633,-0.626],[0.633,0.627],[0,0],[0,0],[-0.633,-0.627],[0.633,-0.627],[0,0]],"v":[[-2.688,3.256],[7.842,-7.168],[10.135,-7.168],[10.135,-4.899],[-2.688,7.794],[-10.135,0.422],[-10.135,-1.847],[-7.842,-1.847]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9765,0.9725,0.9765],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[11.018,8.044],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":1},{"ty":4,"nm":"Shadow","sr":1,"st":0,"op":749.916583249917,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[10.19,20.873,0],"ix":1},"s":{"a":0,"k":[527.525,527.525,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[496.811,444.347,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":4,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,-15.202],[0,0],[0,21.014]],"o":[[0,0],[0,14.965],[0,0],[0,-20.131]],"v":[[-10.467,-20.482],[5.294,-0.351],[-10.467,19.782],[10.467,-0.351]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4667,0.8196,0.5725],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[10.717,20.732],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":2},{"ty":4,"nm":"Circle","sr":1,"st":0,"op":749.916583249917,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[19.958,19.959,0],"ix":1},"s":{"a":0,"k":[527.525,527.525,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[446.191,439.682,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,-11.122],[11.122,0],[0,11.122],[-11.122,0]],"o":[[0,11.122],[-11.122,0],[0,-11.122],[11.122,0]],"v":[[20.138,0],[0,20.138],[-20.138,0],[0,-20.138]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.502,0.8863,0.6196],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[20.388,20.388],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":3},{"ty":4,"nm":"Shape Layer 4","sr":1,"st":14,"op":150,"ip":-2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[286.5,286.5,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[1],"t":33},{"s":[100],"t":34}],"ix":11}},"ef":[],"shapes":[],"ind":4},{"ty":4,"nm":"Shape Layer 2","sr":1,"st":14,"op":152,"ip":-2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[286.5,286.5,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[],"ind":5},{"ty":4,"nm":"Shape Layer 1","sr":1,"st":14,"op":152,"ip":-2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[286.5,286.5,0],"ix":2},"r":{"a":0,"k":0,"ix":10},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":1,"cix":2,"np":3,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[{"c":false,"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-89,90],[84,-83]]}],"t":27},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[{"c":false,"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-89,90],[84,-83]]}],"t":65},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[{"c":false,"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-90.5,92],[81.5,-79.5]]}],"t":68},{"s":[{"c":false,"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-89,90],[84,-83]]}],"t":71}],"ix":2}},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":27},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":30},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":61},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":65},{"s":[100],"t":71}],"ix":2},"o":{"a":0,"k":0,"ix":3},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":27},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":30},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":61},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":65},{"s":[0],"t":71}],"ix":1},"m":1},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":38,"ix":5},"c":{"a":0,"k":[1,0.8784,0.7961],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":6},{"ty":4,"nm":"Layer 2 Outlines","sr":1,"st":14,"op":152,"ip":-2,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0.333,"y":0.333},"i":{"x":0.833,"y":0.833},"s":[241.861,241.861,0],"t":41},{"o":{"x":0.167,"y":0.167},"i":{"x":0.667,"y":0.667},"s":[241.861,241.861,0],"t":45},{"o":{"x":0.333,"y":0.333},"i":{"x":0.833,"y":0.833},"s":[241.861,241.861,0],"t":48},{"s":[241.861,241.861,0],"t":54}],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":41},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":45},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":54},{"s":[100,100,100],"t":60}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[286.031,290.916,0],"t":41,"ti":[0,6.823,0],"to":[0,-6.167,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[286.031,253.916,0],"t":45,"ti":[0,-1,0],"to":[0,-6.823,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.667,"y":1},"s":[286.031,249.98,0],"t":46,"ti":[0,-1.656,0],"to":[0,1,0]},{"o":{"x":0.333,"y":0.333},"i":{"x":0.833,"y":0.833},"s":[286.031,259.916,0],"t":48,"ti":[0,0,0],"to":[0,0,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[286.031,259.916,0],"t":54,"ti":[0,-5.167,0],"to":[0,5.167,0]},{"s":[286.031,290.916,0],"t":60}],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":41},{"o":{"x":0.167,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":45},{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":48},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":54},{"s":[0],"t":60}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":41},{"o":{"x":0.167,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":45},{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":48},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":54},{"s":[100],"t":60}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.667,"y":1},"s":[{"c":true,"i":[[0,-81.109],[81.109,0],[0,81.109],[-81.109,0]],"o":[[0,81.109],[-81.109,0],[0,-81.109],[81.109,0]],"v":[[146.861,0],[0,146.861],[-146.86,0],[0,-146.861]]}],"t":34},{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[{"c":true,"i":[[0,-81.109],[81.109,0],[0,81.109],[-81.109,0]],"o":[[0,81.109],[-81.109,0],[0,-81.109],[81.109,0]],"v":[[146.861,0],[0,146.861],[-146.86,0],[0,-146.861]]}],"t":41},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[{"c":true,"i":[[0,-81.109],[81.109,0],[0,81.109],[-81.109,0]],"o":[[0,81.109],[-81.109,0],[0,-81.109],[81.109,0]],"v":[[146.861,0],[0,146.861],[-146.86,0],[0,-146.861]]}],"t":45},{"s":[{"c":true,"i":[[0,-81.109],[81.109,0],[0,81.109],[-81.109,0]],"o":[[0,81.109],[-81.109,0],[0,-81.109],[81.109,0]],"v":[[146.861,0],[0,146.861],[-146.86,0],[0,-146.861]]}],"t":54}],"ix":2}},{"ty":"st","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":2,"lj":1,"ml":10,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":38,"ix":5},"c":{"a":0,"k":[1,0.8784,0.7961],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[241.861,241.861],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"tm","bm":0,"hd":false,"mn":"ADBE Vector Filter - Trim","nm":"Trim Paths 1","ix":2,"e":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[87],"t":30.2},{"o":{"x":0.167,"y":0},"i":{"x":0.667,"y":1},"s":[50],"t":35},{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":0.833},"s":[50],"t":41},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[41],"t":45},{"o":{"x":0.167,"y":0.167},"i":{"x":0.667,"y":1},"s":[41],"t":46},{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[42],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[42],"t":54},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[3],"t":60},{"s":[2],"t":62}],"ix":2},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":35},{"o":{"x":0.167,"y":0.167},"i":{"x":0.667,"y":1},"s":[-7],"t":37.4},{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":41},{"o":{"x":0.167,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":45},{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":54},{"s":[-53],"t":60}],"ix":3},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[87],"t":29},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[85],"t":30.2},{"o":{"x":0.167,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":35},{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":0.833},"s":[0],"t":41},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[9],"t":45},{"o":{"x":0.167,"y":0.167},"i":{"x":0.667,"y":1},"s":[9],"t":46},{"o":{"x":0.333,"y":0},"i":{"x":0.833,"y":1},"s":[8],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[8],"t":54},{"s":[2],"t":62}],"ix":1},"m":1}],"ind":7},{"ty":4,"nm":"Layer 2 Outlines 2","sr":1,"st":11,"op":152,"ip":-5,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[37.963,37.963,0],"t":28},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[37.963,37.963,0],"t":60},{"s":[37.963,37.963,0],"t":64}],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":28},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,0,100],"t":32},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":34},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":57},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,0,100],"t":60},{"s":[100,100,100],"t":64}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.001},"i":{"x":0.833,"y":0.999},"s":[347.264,349.557,0],"t":28,"ti":[-1.917,21.708,0],"to":[1.833,-20.5,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[358.264,226.557,0],"t":32,"ti":[0,0,0],"to":[1.917,-21.708,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[358.764,219.307,0],"t":34,"ti":[0.083,-1.208,0],"to":[0,0,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[358.264,226.557,0],"t":37,"ti":[0,0,0],"to":[0,0,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[358.264,226.557,0],"t":40,"ti":[0,0,0],"to":[0,0,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[358.264,226.557,0],"t":57,"ti":[1.833,-20.5,0],"to":[-1.833,22.833,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[347.264,363.557,0],"t":60,"ti":[0,2.333,0],"to":[-1.833,20.5,0]},{"s":[347.264,349.557,0],"t":64}],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":28},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":60},{"s":[0],"t":64}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":28},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":60},{"s":[100],"t":64}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,-20.828],[20.826,0],[0,20.828],[-20.828,0]],"o":[[0,20.828],[-20.828,0],[0,-20.828],[20.826,0]],"v":[[37.713,0.001],[-0.001,37.713],[-37.713,0.001],[-0.001,-37.713]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.8784,0.7961],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[37.962,37.963],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":8},{"ty":4,"nm":"Layer 3 Outlines","sr":1,"st":11,"op":133,"ip":-5,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[37.962,37.963,0],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[37.962,37.963,0],"t":37},{"s":[37.962,37.963,0],"t":64}],"ix":1},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":34},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,0,100],"t":37},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":40},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100,100],"t":60},{"s":[100,100,100],"t":64}],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[222.276,226.812,0],"t":24,"ti":[0,0,0],"to":[0,0,0]},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[222.276,226.812,0],"t":37,"ti":[1.333,0,0],"to":[-1.333,0,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[214.276,226.812,0],"t":40,"ti":[0,0,0],"to":[0,0,0]},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[214.276,226.812,0],"t":60,"ti":[-1.333,0,0],"to":[1.333,0,0]},{"s":[222.276,226.812,0],"t":64}],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":24},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[0],"t":37},{"s":[0],"t":64}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":24},{"o":{"x":0.167,"y":0},"i":{"x":0.833,"y":1},"s":[100],"t":37},{"s":[100],"t":64}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,-20.828],[20.828,0],[0,20.828],[-20.829,0]],"o":[[0,20.828],[-20.829,0],[0,-20.828],[20.828,0]],"v":[[37.712,0],[0,37.712],[-37.712,0],[0,-37.712]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[1,0.8784,0.7961],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[37.962,37.962],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":9},{"ty":4,"nm":"Layer 1/Path Outlines","sr":1,"st":0,"op":116,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[14.5,14.5,0],"ix":1},"s":{"a":0,"k":[1789.655,1789.655,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[281.082,290.788,0],"t":21,"ti":[-1,0,0],"to":[1,0,0]},{"s":[287.082,290.788,0],"t":76}],"ix":2},"r":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[0],"t":21},{"s":[90],"t":76}],"ix":10},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[100],"t":21},{"s":[100],"t":76}],"ix":11}},"ef":[],"shapes":[{"ty":"gr","bm":0,"hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":1,"cix":2,"np":2,"it":[{"ty":"sh","bm":0,"hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0.798,0.784],[0,0],[0,0.559],[0,0],[2.325,0],[0,0],[0.392,0.392],[0,0],[1.639,-1.651],[0,0],[0.561,0],[0,0],[0,-2.324],[0,0],[0.392,-0.392],[0,0],[-1.639,-1.637],[0,0],[0,-0.561],[0,0],[-2.325,0],[0,0],[-0.392,-0.392],[0,0],[-1.078,0],[-0.827,0.827],[0,0],[-0.56,0],[0,0],[0,2.325],[0,0],[-0.392,0.392],[0,0],[-0.014,0.016],[0.015,1.12]],"o":[[0,0],[-0.392,-0.392],[0,0],[0,-2.324],[0,0],[-0.56,0],[0,0],[-1.653,-1.638],[0,0],[-0.392,0.392],[0,0],[-2.325,0],[0,0],[0,0.575],[0,0],[-1.639,1.651],[0,0],[0.392,0.406],[0,0],[0,2.325],[0,0],[0.561,0],[0,0],[0.827,0.812],[1.079,0],[0,0],[0.392,-0.392],[0,0],[2.325,0],[0,0],[0,-0.561],[0,0],[0.014,-0.014],[0.784,-0.796],[0,-1.121]],"v":[[12.767,-2.986],[11.759,-3.994],[11.142,-5.477],[11.142,-6.921],[6.927,-11.135],[5.484,-11.135],[4,-11.752],[2.978,-12.773],[-2.989,-12.76],[-3.997,-11.752],[-5.482,-11.135],[-6.924,-11.135],[-11.14,-6.921],[-11.14,-5.493],[-11.756,-3.994],[-12.778,-2.971],[-12.764,2.993],[-11.756,3.988],[-11.14,5.487],[-11.14,6.928],[-6.924,11.145],[-5.482,11.145],[-3.997,11.759],[-2.975,12.783],[0.008,14],[2.992,12.768],[4,11.759],[5.484,11.145],[6.927,11.145],[11.142,6.928],[11.142,5.487],[11.759,4.002],[12.753,3.007],[12.795,2.965],[13.999,-0.017]]},"ix":2}},{"ty":"fl","bm":0,"hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9412,0.3686,0.0902],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[14.667,14.661],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":10}],"v":"4.8.0","fr":25,"op":78,"ip":14,"assets":[]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6886,4386,719,7918,1362,1541,9464,8726,9774,2888,179], function() { return __webpack_exec__(99994); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);